export default {
  name: "Navigation",
  data: () => {
    return {
      showNav: false
    };
  },
  methods: {
    showNavbar() {
      this.showNav = !this.showNav;
    },
    hideNavbar() {
      this.showNav = !this.showNav;
    },
    scrollWin() {
      window.scrollTo(0, 0);
      behavior: "smooth";
    }
    // let mainNav = document.getElementById("js-menu");
    // let navBarToggle = document.getElementById("js-navbar-toggle");
    // navBarToggle.addEventListener("click", function() {
    //   mainNav.classList.toggle("active");
    // });
  }
};